{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/NORTON",
	"name": "NORTON",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "De Nortonschaal",
	"purpose": "Decubituspreventie door risicobepaling",
	"description": "Ingeval een score lager dan 14 dient men de patiënt als risicopatiënt te beschouwen. De auteurs (Norton, McLaren & Exton-Smith, 1962) gaan er van uit dat de ontwikkeling van decubitusletsels gegarandeerd is indien de score lager ligt dan 12.",
	"item": [
		{
			"linkId": "175",
			"text": "Algemeen lichamelijke toestand",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "440",
						"display": "Slecht"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "441",
						"display": "Matig"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "442",
						"display": "Redelijk"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "443",
						"display": "Goed"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "177",
			"text": "Geestelijke toestand",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "444",
						"display": "Onbewust"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "445",
						"display": "Verward"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "446",
						"display": "Apatisch"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "447",
						"display": "Goed, alert"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "179",
			"text": "Activiteit",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "448",
						"display": "Bedgebonden"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "449",
						"display": "Stoelgebonden"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "450",
						"display": "Ambulant + hulp"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "451",
						"display": "Ambulant"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "181",
			"text": "Mobiliteit",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "452",
						"display": "Immobiel"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "453",
						"display": "Ernstig beperkt"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "454",
						"display": "Licht beperkt"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "455",
						"display": "Volledig"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "183",
			"text": "Incontinentie",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "456",
						"display": "Volledig (urine+faeces)"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "457",
						"display": "Geregeld"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "458",
						"display": "Af en toe"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "459",
						"display": "Niet"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		}
	]
}
